<template>
    <div :class="mainContainerClass">
        <div class="dropzone-container"
             @dragover="dragover"
             @dragleave="dragleave"
             @drop="drop">
            <input type="file"
                   multiple
                   name="file"
                   id="fileInput"
                   class="hidden-input"
                   @change="onChange"
                   ref="file"
                   accept=".csv" />

            <label for="fileInput" class="file-label">
                <div v-if="isDragging">Release to drop files here.</div>
                <div v-else>Drop files here or <u>click here</u> to upload.</div>
            </label>
            <div class="preview-container mt-4" v-if="files.length">
                <div v-for="file in files" :key="file.name" class="preview-card">
                    <div>
                        <img class="preview-img" :src="generateURL(file)" />
                        <p>
                            {{ file.name }}
                            {{ Math.round(file.size / 1000) + "kb" }}
                        </p>
                    </div>
                    <div>
                        <button class="ml-2"
                                type="button"
                                @click="remove(files.indexOf(file))"
                                title="Remove file">
                            <b>×</b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            mainContainerClass: {
                type: String,
                required: false,
                default: () => { return 'main'; }
            }
        },
      data() {
        return {
          isDragging: false,
          files: [],
        };
      },
      methods: {
        onChange() {
              this.files = [...this.$refs.file.files];
          this.$emit('change', this.files)
        },
        dragover(e) {
          e.preventDefault();
          this.isDragging = true;
        },
        dragleave() {
          this.isDragging = false;
        },
        drop(e) {
          e.preventDefault();
          this.$refs.file.files = e.dataTransfer.files;
          this.onChange();
          this.isDragging = false;
          },
          remove(i) {
              this.files.splice(i, 1);
          },
          generateURL(file) {
              let fileSrc = URL.createObjectURL(file);
              setTimeout(() => {
                  URL.revokeObjectURL(fileSrc);
              }, 1000);
              return fileSrc;
          },
          init() {
              this.files = []
          }
       },
    };
</script>
<style scoped src="@/assets/css/dropfile.css"></style>